import {
  getLocalStorageItem,
  setLocalStorageItem,
} from '@marketplace-web/browser/browser-storage-util'

import { getCurrentTimeInSeconds } from './date'

const SECONDS_PER_WEEK = 60 * 60 * 24 * 7

export const getIsBumpAgainSuggestionSeen = () => {
  const seenOn = getLocalStorageItem('bump_again_suggestion_on')

  if (!seenOn) return false

  const seenOnInSeconds = Number(seenOn)
  const currentTimeInSeconds = getCurrentTimeInSeconds()

  return currentTimeInSeconds - seenOnInSeconds < SECONDS_PER_WEEK
}

export const setBumpAgainSuggestionAsSeen = () => {
  const currentTimeInSeconds = getCurrentTimeInSeconds()

  setLocalStorageItem('bump_again_suggestion_on', currentTimeInSeconds.toString())
}
